import type { Tinypass } from '@/main/lib/services/Piano/entities/Tinypass';

/**
 * Checks if a submitted email matches an existing Piano account, either by comparing to logged in user's email
 * or by checking if a Piano account exists for the email via API.
 *
 *
 * @param email - The submitted email
 * @param tp - Tinypass
 * @returns true if email matches an existing Piano account (either logged in or not), false otherwise
 */
export async function checkPianoAccountExists(
  email: string,
  tp: Tinypass,
): Promise<{ hasAccount: true; userId: string } | { hasAccount: false }> {
  const loggedInUser = tp.pianoId.getUser();

  if (loggedInUser?.email === email) {
    return { hasAccount: true, userId: loggedInUser.uid };
  }

  const response = await fetch(`/api/piano/getUser/${encodeURIComponent(email)}`);
  if (response.ok) {
    const data = await response.json();
    if (data.success) {
      return { hasAccount: true, userId: data.userId };
    }
  }
  return { hasAccount: false };
}
